import { heroContent } from '@/mocks/appData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20warm%20amber%20and%20cream%20gradient%20background%20with%20soft%20flowing%20curves%2C%20minimal%20modern%20design%2C%20subtle%20glass%20morphism%20texture%2C%20clean%20elegant%20atmosphere%2C%20no%20text%20no%20people%2C%20artistic%20abstract%20composition%20with%20warm%20orange%20and%20beige%20tones&width=1800&height=1200&seq=hero-bg-cpp&orientation=landscape"
          alt="CPP官网"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-16">
        <div className="max-w-[1280px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-8">
            <i className="ri-sparkling-2-line text-primary-400 text-sm"></i>
            <span className="text-xs text-background-50/90">{heroContent.badgeText}</span>
            <span className="text-xs text-background-50/50">·</span>
            <span className="text-xs text-background-50/70">{heroContent.badgeSub}</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
            {heroContent.title}
          </h1>
          <p className="text-lg md:text-xl text-primary-300 font-medium mb-4">
            {heroContent.subtitle}
          </p>
          <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-10 leading-relaxed">
            {heroContent.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 shadow-lg shadow-primary-500/25"
            >
              <i className="ri-android-line mr-2"></i>
              Android 下载
            </a>
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold whitespace-nowrap rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 hover:bg-background-50/25 transition-all duration-300"
            >
              <i className="ri-apple-line mr-2"></i>
              iOS 下载
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 text-background-50/60">
            <div className="flex items-center gap-2">
              <i className="ri-download-cloud-2-line text-primary-400"></i>
              <span className="text-sm">{heroContent.downloads} 次下载</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-star-fill text-primary-400"></i>
              <span className="text-sm">{heroContent.rating} 分 · {heroContent.ratingCount} 评价</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}